export default __webpack_public_path__ + "assets/images/icon-ai.0b9a793ed606cd19574ce048779c97cc.svg";